/**
 * usePublishListContextBridge — thin wrapper that shapes listing state into
 * the legacy context payload and publishes it via usePublishListContext.
 *
 * A15 from listing-abstraction-opportunities.md
 *
 * Encapsulates the publish-state memoization pattern so listings don't inline
 * the payload shaping logic. The payload shape is injectable via the
 * buildPublishPayload option so this module stays domain-neutral.
 *
 * When usePublishListContext is undefined (legacy pages without the chat
 * widget mount), this is a no-op.
 */
import { useMemo } from 'react';
import { usePublishListContext } from '@features/AIChatWidget/hooks/usePublishListContext';
export function usePublishListContextBridge({ page, sort, filters, search, totalCount, rows }) {
    const publishState = useMemo(() => ({
        page: {
            skip: (page.number - 1) * page.size,
            take: page.size
        },
        sort: sort ? [{ field: sort.field, dir: sort.direction }] : null,
        filters: filters,
        totalCount,
        data: rows,
        search: search !== null && search !== void 0 ? search : ''
    }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [page.number, page.size, sort, filters, search, totalCount, rows]);
    usePublishListContext(publishState);
}
